import { devLocalStorage } from '../application/dev_local_storage';
import { Logger } from './logger/logger';

export namespace DebugConfig {
	export interface LocalStorageConfig extends WindowVisiba.Global {
		log: {
			level: Logger.Level;
			output: string;
			save: boolean;
		};
	}

	function saveDebugConfig(): void {
		devLocalStorage.set('config', {
			allowMobile: window.__visiba__.allowMobile,
			RR: {
				debug: window.__visiba__.RR.debug,
			},
			log: {
				level: Logger.state.level,
				output: 'console',
				save: Logger.state.storeValues,
			},
		});
	}

	function parseAllowMobile(value: string | null): boolean | null {
		if (value === 'true') {
			return true;
		}
		if (value === 'false') {
			return false;
		}
		return null;
	}

	const config = devLocalStorage.get('config');

	const url = new URL(location.href);
	const search = new URLSearchParams(url.search);
	const secretQueryParam = search.get('__SECRET_ALLOW_MOBILE_DO_NOT_USE');
	const allowMobile = parseAllowMobile(secretQueryParam);

	const mirrorState = {
		allowMobile: allowMobile ?? config?.allowMobile ?? false,
		debug: config?.RR?.debug ?? false,
	};

	// Sets up global object for the browser
	window.__visiba__ = {
		set allowMobile(value: boolean) {
			mirrorState.allowMobile = value;

			saveDebugConfig();
		},
		get allowMobile(): boolean {
			return mirrorState.allowMobile;
		},
		RR: {
			set debug(value: boolean) {
				mirrorState.debug = value;

				saveDebugConfig();
			},
			get debug(): boolean {
				return mirrorState.debug;
			},
		},
		log: {
			get level(): Logger.Level {
				return Logger.state.level;
			},
			set level(level: Logger.Level) {
				const levelBeforeUpdate = Logger.state.level;

				Logger.setLogLevel(level);

				if (process.env.NODE_ENV !== 'test') {
					if (levelBeforeUpdate !== level && level === Logger.state.level) {
						Logger.print('updated level');
					} else {
						Logger.print('invalid level', Logger.Level.error);
					}
				}

				saveDebugConfig();
			},
			get output(): string {
				return `\n${Logger.storedLogs.join('\n')}\n`;
			},
		},
	};

	saveDebugConfig();
}
